import React, {useState, useEffect, useRef} from "react";
import axios from "axios";
import {base, get_contract_types} from "../../api";
import {Link} from "react-router-dom";
import {Dialog} from "primereact/dialog";
import {Toast} from "primereact/toast";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {Button} from "primereact/button";
import ProcessesDocumentationAddForm from "./ProcessesDocumentationAddForm";
import ProcessesDocumentationEditForm from "./ProcessesDocumentationEditForm";
import {Tooltip} from "primereact/tooltip";

export default function ProcessesDocumentation() {
	const toast = useRef(null);
	const headers = {"Content-Type": "application/json"};
	const credentials = "same-origin";
	const [processes, setProcesses] = useState([]);
	const [dialogVisible, setDialogVisible] = useState(false);
	const [editDialogVisible, setEditDialogVisible] = useState(false);
	const [newProcess, setNewProcess] = useState({name: "", icon: "pi-cog"});
	const [editProcess, setEditProcess] = useState(null);

	useEffect(() => {
		fetchProcesses();
	}, []);

	const fetchProcesses = async () => {
		try {
			const response = await axios.get(base + get_contract_types);
			setProcesses(response.data);
		} catch (error) {
			console.error("Error fetching processes:", error);
		}
	};
	const handleAddProcess = () => {
		if (newProcess.name.trim()) {
			setProcesses(prev => [...prev, {...newProcess, id: prev.length + 1}]);
			setDialogVisible(false);
			setNewProcess({name: "", icon: "pi-cog"});
			toast.current.show({
				severity: "success",
				summary: "Added",
				detail: "New process added",
				life: 3000,
			});
		}
	};

	const handleEditProcess = () => {
		setProcesses(prev => prev.map(proc => (proc.id === editProcess.id ? editProcess : proc)));
		setEditDialogVisible(false);
		toast.current.show({
			severity: "success",
			summary: "Updated",
			detail: "Process updated",
			life: 3000,
		});
	};

	const remove = id => {
		axios
			.delete(`${base + get_contract_types}/${id}/`, {headers})
			.then(() => {
				fetchProcesses();
				// setProcesses(prev => prev.filter(proc => proc.id !== id));
				toast.current.show({
					severity: "success",
					summary: "Deleted",
					detail: "Process deleted successfully",
					life: 3000,
				});
			})
			.catch(error => {
				console.error("Error deleting process:", error);
				toast.current.show({
					severity: "error",
					summary: "Error",
					detail: "Failed to delete process",
					life: 3000,
				});
			});
	};

	const accept = id => {
		toast.current.show({
			severity: "success",
			summary: "Confirmed",
			detail: "You have accepted",
			life: 3000,
		});
		remove(id);
	};

	const reject = () => {
		toast.current.show({
			severity: "warn",
			summary: "Rejected",
			detail: "You have rejected",
			life: 3000,
		});
	};

	const confirmDelete = id => {
		confirmDialog({
			message: "Do you want to delete this record?",
			header: "Delete Confirmation",
			icon: "pi pi-info-circle",
			acceptClassName: "p-button-danger",
			accept: () => accept(id),
			reject,
		});
	};

	return (
		<div className="col-12 p-0 my-4">
			<Toast ref={toast} />
			<ConfirmDialog />
			<div className="card b-radius b-shadow border-0 p-3">
				<p className="d-flex align-items-center text-muted mb-0 text-uppercase">
					Փաստաթղթավորման բոլոր գործընթացները
				</p>
				<hr />
				<div className="col-12">
					<div className="row">
						{processes.map((item, index) => (
							<div key={index} className="col-xl-3 col-lg-4 col-md-4 col-6 stretch-card p-3">
								<div className="card hover processes b-shadow b-radius w-100 pt-3 pb-5 border-0 position-relative">
									<Link
										to={item.slug || "#"}
										className="card-body justify-content-center text-center">
										<div className="icon-holder b-shadow mt-3 mb-4">
											<i className={`pi ${item.icon} fs-3 p-3 text-${item.color}`}></i>
										</div>
										<span className="mb-0 text-uppercase">{item.name}</span>
									</Link>
									<div className="position-absolute top-0 end-0 m-2 gap-2">
										<Button
											icon="pi pi-pencil"
											text
											rounded
											severity="secondary"
											className="p-0"
											onClick={() => {
												setEditProcess(item);
												setEditDialogVisible(true);
											}}
											data-pr-tooltip="Edit Process"
											data-pr-position="bottom"
										/>
										<Button
											icon="pi pi-trash"
											text
											rounded
											severity="secondary"
											className="p-0"
											onClick={() => confirmDelete(item.id)}
											data-pr-tooltip="Delete Process"
											data-pr-position="bottom"
										/>
										<Tooltip target=".p-button" />
									</div>
								</div>
							</div>
						))}
						<div className="col-xl-3 col-lg-4 col-md-4 col-6 stretch-card p-3">
							<div
								className="card hover b-shadow b-radius w-100 pt-3 pb-5 border-0"
								onClick={() => setDialogVisible(true)}>
								<div className="card-body justify-content-center text-center">
									<div className="icon-holder b-shadow mt-3 mb-4">
										<i className="pi pi-plus fs-3 p-3 text-success"></i>
									</div>
									<span className="mb-0 text-uppercase">Ավելացնել նոր Գործընթաց</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Dialog
				visible={dialogVisible}
				onHide={() => setDialogVisible(false)}
				className="col-lg-8 col-11 mx-auto"
				header="Ավելացնել նոր գործընթաց">
				<ProcessesDocumentationAddForm
					process={newProcess}
					setProcess={setNewProcess}
					onSave={handleAddProcess}
					setDialogVisible={setDialogVisible}
					dialogVisible={dialogVisible}
					fetchProcesses={fetchProcesses}
					toast={toast}
				/>
			</Dialog>

			<Dialog
				visible={editDialogVisible}
				className="col-lg-8 col-11 mx-auto"
				onHide={() => setEditDialogVisible(false)}
				header="Խմբագրել գործընթաց">
				<ProcessesDocumentationEditForm
					process={editProcess}
					setProcess={setEditProcess}
					editDialogVisible={editDialogVisible}
					setEditDialogVisible={setEditDialogVisible}
					onSave={handleEditProcess}
					fetchProcesses={fetchProcesses}
					toast={toast}
				/>
			</Dialog>
		</div>
	);
}
